var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from 'react';
import { Form } from 'formik';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';
import { Spacer } from '../../../../uikit/misc/Spacer';
import { mainFormSlice } from '../../../../store/mainForm/mainForm.slice';
import { FormikForm } from '../../../../components/molecules/FormikForm';
import { RadioGroupFormikField as RadioGroup } from '../../../../components/molecules/FormFields/RadioGroupField';
import { SelectFormikField as Select } from '../../../../components/molecules/FormFields/SelectField';
import { CurrencyInputFormikField as CurrencyInput } from '../../../../components/molecules/FormFields/CurrencyInputField';
import { DatepickerFormikField as Datepicker } from '../../../../components/molecules/FormFields/DatepickerField';
import { MaskedNumericInputFormikField as MaskedNumericInput } from '../../../../components/molecules/FormFields/MaskedNumericInputField';
import { projectPageModel } from './formModel';
import { PROJECT_STATUSES, PURPOSES_OF_USE, } from './formModel.types';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
import constants from './constants';
import { inputMasks } from '../../../../utils/inputMasks.utils';
import { PostalAddressSubForm } from '../../../../subforms/PostalAddressSubForm';
import { MAIN_FORM_STEPS } from '../../../../store/mainForm/mainForm.types';
import { MainFormFooter } from '../../../../components/molecules/MainFormFooter';
var objectTypesGroupOptions = constants.objectTypesGroupOptions, houseTypeOptions = constants.houseTypeOptions, yesNoOptions = constants.yesNoOptions, objectTypeOfUseOptions = constants.objectTypeOfUseOptions;
var t = getTranslation(translations);
var PATHS = projectPageModel.paths, SELECTORS = projectPageModel.selectors, helpers = projectPageModel.helpers, validationSchema = projectPageModel.validationSchema;
var mapStateToProps = function (state) { return ({
    initialValues: mainFormSlice.selectors.getProjectData(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    saveProjectState: function (projectFields) {
        return dispatch(mainFormSlice.actions.saveProjectData(projectFields));
    },
    setProjectData: function (projectFields) {
        return dispatch(mainFormSlice.actions.setProjectData(projectFields));
    },
    goToPrevPage: function () {
        return dispatch(mainFormSlice.actions.setActiveStep(MAIN_FORM_STEPS.APPLICANT_PAGE));
    },
    goToNextPage: function () {
        return dispatch(mainFormSlice.actions.setActiveStep(MAIN_FORM_STEPS.APPLICANT_OCCUPATION_PAGE));
    },
}); };
export var ProjectPage = function (_a) {
    var goToPrevPage = _a.goToPrevPage, goToNextPage = _a.goToNextPage, saveProjectState = _a.saveProjectState, setProjectData = _a.setProjectData, initialValues = _a.initialValues;
    return (React.createElement(FormikForm, { initialValues: initialValues, validateOnChange: false, validationSchema: validationSchema, onSubmit: function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, saveProjectState(values)];
                    case 1:
                        _a.sent();
                        actions.setSubmitting(false);
                        goToNextPage();
                        return [2 /*return*/];
                }
            });
        }); } }, function (formik) {
        var values = formik.values;
        useEffect(function () {
            // UGLY SOLUTION!!!, it will work properly only until
            // all helpers called at effect body will be based on PURPOSE_OF_USE
            if (helpers.isAddressRequired(values)) {
                formik.setFieldValue(PATHS.IS_POSTAL_ADDRESS_KNOWN, true);
            }
            if (helpers.isExistingLoanPresentedFieldRequired(values)) {
                formik.setFieldValue(PATHS.IS_EXISTING_LOAN_PRESENTED, true);
            }
        }, [SELECTORS.PURPOSE_OF_USE(values)]);
        useEffect(function () {
            var purposeOfUse = SELECTORS.PURPOSE_OF_USE(values);
            var isPostalAddressKnown = SELECTORS.IS_POSTAL_ADDRESS_KNOWN(values);
            if (isPostalAddressKnown === true &&
                !helpers.shouldSetProjectStatus(values)) {
                return;
            }
            var nextProjectStatus = purposeOfUse === PURPOSES_OF_USE.CONSTRUCTION
                ? PROJECT_STATUSES.LOOKING_FOR_PARCEL
                : PROJECT_STATUSES.LOOKING_FOR_OBJECT;
            formik.setFieldValue(PATHS.PROJECT_STATUS, nextProjectStatus);
        }, [
            SELECTORS.PURPOSE_OF_USE(values),
            SELECTORS.IS_POSTAL_ADDRESS_KNOWN(values),
        ]);
        var handleBackButtonClick = function () {
            setProjectData(values);
            goToPrevPage();
        };
        var baseCostFieldLabel = helpers.getLabelForBaseCostField(values);
        return (React.createElement(Form, { noValidate: true },
            React.createElement(Typography, { variant: "h3" }, t.title),
            React.createElement(Spacer, { size: 3 }),
            React.createElement(CurrencyInput, { name: PATHS.LOAN_AMOUNT, label: t.loanAmountLabel, description: t.loanAmountDescription }),
            React.createElement(Select, { name: PATHS.LOAN_TIME_OF_DEMAND, label: t.loanTimeOfDemandLabel, options: constants.loanTimeOfDemandOptions }),
            React.createElement(CurrencyInput, { name: PATHS.AVAILABLE_EQUITY, label: t.availableEquityLabel, isOptional: true }),
            React.createElement(RadioGroup, { name: PATHS.OBJECT_GROUP_TYPE, label: t.objectTypesGroupLabel, description: t.objectTypesGroupDescription, options: objectTypesGroupOptions }),
            helpers.shouldShowHouseTypeField(values) && (React.createElement(Select, { name: PATHS.OBJECT_TYPE, options: houseTypeOptions })),
            React.createElement(Select, { name: PATHS.PURPOSE_OF_USE, options: helpers.getDynamicPurposeOfUseOptions(values) }),
            helpers.shouldShowMarketValue(values) && (React.createElement(CurrencyInput, { name: PATHS.MARKET_VALUE, label: t.marketValueLabel })),
            helpers.shouldShowBaseCostField(values) && (React.createElement(CurrencyInput, { name: PATHS.BASE_COST, label: baseCostFieldLabel, description: t.baseCostDescription })),
            helpers.shouldShowAdditionalCost(values) && (React.createElement(CurrencyInput, { name: PATHS.ADDITIONAL_COST, label: helpers.getLabelForAdditionalPriceField(values), isOptional: helpers.isAdditionalCostOptional(values) })),
            React.createElement(Spacer, { size: 2 }),
            helpers.shouldShowIsPostalAddressKnown(values) && (React.createElement(RadioGroup, { name: PATHS.IS_POSTAL_ADDRESS_KNOWN, label: t.isPostalAddressKnownLabel, description: t.isPostalAddressKnownDescription, options: yesNoOptions })),
            helpers.shouldShowKnownPropertyFields(values) && (React.createElement(React.Fragment, null,
                React.createElement(PostalAddressSubForm, { namespace: PATHS.POSTAL_ADDRESS }),
                helpers.shouldShowProjectStatus(values) && (React.createElement(Select, { label: t.projectStatusLabel, name: PATHS.PROJECT_STATUS, options: helpers.getProjectStatusOptions(values) })),
                helpers.shouldShowAreaInSqm(values) && (React.createElement(MaskedNumericInput, { name: PATHS.AREA_IN_SQM, label: t.areaInSqmLabel, isOptional: true, placeholder: t.areaInSqmPlaceholder, mask: inputMasks.getFloatNumberMask() })),
                helpers.shouldShowYearOfConstruction(values) && (React.createElement(MaskedNumericInput, { name: PATHS.YEAR_OF_CONSTRUCTION, label: t.yearOfConstructionLabel, isOptional: true, placeholder: t.yearOfConstructionPlaceholder, allowFormat: false, mask: inputMasks.getYearMask() })),
                React.createElement(Spacer, { size: 2 }))),
            helpers.shouldShowObjectGroupTypeField(values) && (React.createElement(React.Fragment, null,
                React.createElement(RadioGroup, { name: PATHS.OBJECT_TYPE_OF_USE, label: t.objectTypeOfUseLabel, description: t.objectTypeOfUseDescription, options: objectTypeOfUseOptions }),
                React.createElement(Spacer, { size: 2 }))),
            helpers.shouldShowExistingLoanBlock(values) && (React.createElement(React.Fragment, null,
                !helpers.isExistingLoanPresentedFieldRequired(values) && (React.createElement(RadioGroup, { name: PATHS.IS_EXISTING_LOAN_PRESENTED, label: t.isExistingLoanPresentedLabel, options: yesNoOptions })),
                helpers.isExistingLoanPresented(values) && (React.createElement(React.Fragment, null,
                    React.createElement(Datepicker, { name: PATHS.FIXED_INTEREST_RATE_UNTIL, label: t.fixedInterestRateUntilLabel }),
                    React.createElement(CurrencyInput, { name: PATHS.RESIDUAL_DEBT, label: t.residualDebtLabel }),
                    React.createElement(CurrencyInput, { name: PATHS.MONTHLY_REPAYMENT, label: t.monthlyRepaymentLabel }))),
                React.createElement(Spacer, { size: 2 }))),
            React.createElement(Spacer, { size: 3 }),
            React.createElement(MainFormFooter, { isForwardDisabled: formik.isSubmitting, onBackwardBtnClick: handleBackButtonClick })));
    }));
};
export default connect(mapStateToProps, mapDispatchToProps)(ProjectPage);
